import { Injectable } from "@angular/core";
import { AccountDeviceFacade } from "@youm-front/account-device/data-access";
import {
  AudioInputDeviceDisabled,
  VideoInputDeviceDisabled
} from "@youm-front/account-device/domain";
import { LocalConferenceStreamsListService } from "@youm-front/conference-stream/data-access";
import { LocalCamMicConferenceStream } from "youm-lib/conference";

@Injectable()
export class LocalCamMicStreamService {
  constructor(
    private readonly accountDeviceFacade: AccountDeviceFacade,
    private readonly localConferenceStreamsListService: LocalConferenceStreamsListService
  ) {}

  async audioDisable() {
    const ls = this.camMicStreamGet();
    await ls?.audioDisable();

    this.accountDeviceFacade.audioInputDeviceDisabledSet(
      true as AudioInputDeviceDisabled
    );
  }

  async audioEnable() {
    const ls = this.camMicStreamGet();
    await ls?.audioEnable();

    this.accountDeviceFacade.audioInputDeviceDisabledSet(
      false as AudioInputDeviceDisabled
    );
  }

  async videoDisable() {
    const ls = this.camMicStreamGet();
    // On the Mixer side, video doesn't have a background.
    // It leverages disabled video stream full of black pixels.
    await ls?.videoDisable();

    this.accountDeviceFacade.videoInputDeviceDisabledSet(
      true as VideoInputDeviceDisabled
    );
  }

  async videoEnable() {
    const ls = this.camMicStreamGet();
    await ls?.videoEnable();

    this.accountDeviceFacade.videoInputDeviceDisabledSet(
      false as VideoInputDeviceDisabled
    );
  }

  private camMicStreamGet() {
    const ls = this.localConferenceStreamsListService.streams.find(
      (_) => _.isCamMic
    );
    if (!ls) {
      return;
    }

    return ls as LocalCamMicConferenceStream;
  }
}
